export type CodiceDescrizione = {
    codice: string;
    descrizione: string;
    value: string;
    label: string;
}

export const codiceDescrizioneNullValue: CodiceDescrizione = {
    codice: '',
    descrizione: '',
    label: '',
    value: '',
}

export type ProvinciaUffici = {
    provincia: CodiceDescrizione;
    value: string;
    label: string;
    codiceDb: string;
    descrizione: string;
    uffici: CodiceDescrizione[];
    ambienti: string[];
}

export type UserContextBase = {
    id: number;
    authorizationId: number;
    name: string;
    ufficio: string;
    provincia: string;
    codice: string;
    descriCodice: string;
    livello: string;
    authorizationToken: string;
}

export type UserContext = UserContextBase & {
    xSixContext: string,
    ufficioCorrente: string,
    aree: string[],
    province: ProvinciaUffici[],
    descrizioneProvincia: string,
    consentiMarketing: boolean,
    banner: boolean,
    notizia: boolean,
    notifica: string
}

export type AmbienteSelector = CodiceDescrizione & {
    uffici: CodiceDescrizione[];
}

export type ProvinciaSelector = CodiceDescrizione & {
    ambienti: AmbienteSelector[];
}

export type UserContextSelector = {
    province: ProvinciaSelector[];
}
